import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MaterialModule } from "src/app/material";
import { BackgroundComponent } from "./background.component";

@NgModule({
    declarations: [
        BackgroundComponent,
    ],
    exports: [
        BackgroundComponent,
    ],
    imports: [
        MaterialModule,
        BrowserModule,
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
  })
  export class BackgroundModule { }